import * as React from "react";
import {RaisedButton} from "../common/RaisedButton";
import {defaultButtonStyle} from "../common/buttonStyles";
import {navigateTo} from "../../../navigateTo";
import {FormattedMessage} from "react-intl";
import {getTranslation} from "../../utils/translationUtil";

export const RESEARCH_DESCRIPTION = "Explore Aon's views on your managers and strategies";
export const HomeResearch: React.FunctionComponent = () => {
    const renderResearchButton = () => {
        return <RaisedButton
            className="home-research__documents-button"
            style={ defaultButtonStyle }
            onClick={() => navigateTo("/research")}
            primary={true}
        >
            <FormattedMessage id="subnav.researchItem" defaultMessage="Research" />
        </RaisedButton>;
    };

    return <div className="home-research__container">
        <div className="home-research__icon"/>
        <div className="home-documents-research__title-container">
            <div className="home-documents-research__title" data-testid="home-research__title">
                {getTranslation("subnav.researchItem", "Research")}
            </div>
            <div className="home-documents-research__description">
                {getTranslation("home.research.description", RESEARCH_DESCRIPTION)}
            </div>
            <div className="home-research__button-container">{renderResearchButton()}</div>
        </div>
    </div>;
};